<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>Órgão - Setorialista</h2>
    <h3>Admin</h3>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <div class="info-page">
            <h3>{{ actionLabel }}</h3>
          </div>

          <form [formGroup]="form" (ngSubmit)="salvar()" *ngIf="!isLoading">
            <div class="form-group row m-b">
              <div class="col-sm-10 col-xl-6">
                <label class="col-sm-12 pb-1">Órgão responsável</label>
                <ng-select id="agency" class="ng-select-alternative" [items]="orgaoList" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Selecione o Órgão" formControlName="agency_id">
                </ng-select>
                <app-field-message [field]="fieldMessageRequired('agency_id')" [erros]="fieldErros('agency_id')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-10 col-xl-6">
                <label class="col-sm-12 pb-1">Setorialista de Captação</label>
                <ng-select id="user_cpf" class="ng-select-alternative" [items]="usuarioList" bindLabel="label" bindValue="id" placeholder="Selecione o Usuário" formControlName="user_cpf">
                </ng-select>
                <app-field-message [field]="fieldMessageRequired('user_cpf')" [erros]="fieldErros('user_cpf')"></app-field-message>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row d-flex justify-content-end">
              <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                <button class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>